import { useState, useEffect } from 'react'

import AuthService from 'modules/auth/service'
import { User } from '../types'
import { Events } from 'common/types'

const useFetchUserByToken = () => {
  const [user, setUser] = useState<User>()
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchUser = async () => {
      const token = AuthService.getToken()

      try {
        if (token) {
          const response = await AuthService.getUserByToken(token)

          setUser(response)
        }
      } catch (error) {
        window.dispatchEvent(new CustomEvent(Events.LIVE_FETCH_USER_ERROR, { detail: error }))
      } finally {
        setLoading(false)
      }
    }

    fetchUser()
  }, [])

  return {
    user,
    loading
  }
}

export default useFetchUserByToken
